var map = {
	"./integrations-helpers": "Jv50",
	"./integrations-helpers.js": "Jv50",
	"./test-integrations": "GGTk",
	"./test-integrations.js": "GGTk",
	"./total-rewards-integrations": "hYQC",
	"./total-rewards-integrations.js": "hYQC"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "NZ9w";